import {isFulfilVersion} from 'utils/common';

export default {};

export const calcTableEntriesInfo = ({itemsPerPage, currentPage, totalCount, locale}) => {
  const first = Math.min((currentPage - 1) * itemsPerPage + 1, totalCount);
  const last = Math.min(currentPage * itemsPerPage, totalCount);
  switch (locale) {
    case 'zh-tw':
      return `正在展示${totalCount}條數據中第${first}到${last}條`;
    default:
      return `Showing ${first} to ${last} of ${totalCount} ${totalCount === 1 ? 'entry' : 'entries'}`;
  }
};
